import { render, staticRenderFns } from "./DefaultBeneFits.vue?vue&type=template&id=3da7c4da&scoped=true&"
import script from "./DefaultBeneFits.vue?vue&type=script&lang=js&"
export * from "./DefaultBeneFits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da7c4da",
  null
  
)

export default component.exports